export function isValidCoords(lat, lon) {
  return latitude(lat) && longitude(lon);
}

function longitude(lon) {
  return Boolean(isNumber(lon) && between(lon, -180, 180));
}

function latitude(lat) {
  return Boolean(isNumber(lat) && between(lat, -90, 90));
}

function isNumber(num) {
  return typeof num === 'number';
}

function between(value, n1, n2) {
  return n1 <= value && n2 >= value;
}

export default {
  isValidCoords,
};
